var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-app",
    {
      nativeOn: {
        drop: function ($event) {
          $event.preventDefault()
        },
        dragover: function ($event) {
          $event.preventDefault()
        },
      },
    },
    [
      _vm.loggedIn && _vm.ready
        ? [
            _c(
              "div",
              { staticClass: "wrapper" },
              [
                _c(
                  "w-scroll-view",
                  {
                    class: { collapsed: _vm.collapsed },
                    style: { flexShrink: 0 },
                    attrs: { tag: "w-drawer" },
                    model: {
                      value: _vm.drawer,
                      callback: function ($$v) {
                        _vm.drawer = $$v
                      },
                      expression: "drawer",
                    },
                  },
                  [
                    _c(
                      "w-drawer-item",
                      {
                        attrs: {
                          disabled: !_vm.hasPermission("companies.read"),
                          to: "/companies",
                        },
                      },
                      [
                        _c("w-fa", { attrs: { icon: "building" } }),
                        _c("span", [_vm._v("Accounts")]),
                      ],
                      1
                    ),
                    _c(
                      "w-drawer-item",
                      {
                        attrs: {
                          disabled: !_vm.hasPermission("companies.read"),
                          to: "/subscriptions",
                        },
                      },
                      [
                        _c("w-fa", { attrs: { icon: "coins" } }),
                        _c("span", [_vm._v("Abonnementen")]),
                      ],
                      1
                    ),
                    _c(
                      "w-drawer-item",
                      {
                        attrs: {
                          disabled: !_vm.hasPermission("modules"),
                          to: "/modules",
                        },
                      },
                      [
                        _c("w-fa", { attrs: { icon: "shapes" } }),
                        _c("span", [_vm._v("Modules")]),
                      ],
                      1
                    ),
                    _c(
                      "w-drawer-item",
                      {
                        attrs: {
                          disabled: !_vm.hasPermission("metrics"),
                          to: "/sales",
                        },
                      },
                      [
                        _c("w-fa", { attrs: { icon: "chart-line" } }),
                        _c("span", [_vm._v("Sales")]),
                      ],
                      1
                    ),
                    _c(
                      "w-drawer-item",
                      {
                        attrs: {
                          disabled: !_vm.hasPermission("metrics"),
                          to: "/metrics",
                        },
                      },
                      [
                        _c("w-fa", { attrs: { icon: "chart-area" } }),
                        _c("span", [_vm._v("Metrics")]),
                      ],
                      1
                    ),
                    _c(
                      "w-drawer-item",
                      {
                        attrs: {
                          disabled: !_vm.hasPermission("tickets"),
                          to: "/tickets",
                        },
                      },
                      [
                        _c("w-fa", { attrs: { icon: "life-ring" } }),
                        _c("span", [_vm._v("Tickets")]),
                      ],
                      1
                    ),
                    _c(
                      "w-drawer-item",
                      {
                        attrs: {
                          disabled: !_vm.hasPermission("logs"),
                          to: "/logs",
                        },
                      },
                      [
                        _c("w-fa", { attrs: { icon: "bug" } }),
                        _c("span", [_vm._v("Logs")]),
                      ],
                      1
                    ),
                    _c(
                      "w-drawer-item",
                      {
                        attrs: {
                          disabled: !_vm.hasPermission("motd"),
                          to: "/motd",
                        },
                      },
                      [
                        _c("w-fa", { attrs: { icon: "bell" } }),
                        _c("span", [_vm._v("Motd")]),
                      ],
                      1
                    ),
                    _c(
                      "w-drawer-item",
                      {
                        attrs: {
                          disabled: !_vm.hasPermission("roadmap"),
                          to: "/roadmap",
                        },
                      },
                      [
                        _c("w-fa", { attrs: { icon: "tasks" } }),
                        _c("span", [_vm._v("Roadmap")]),
                      ],
                      1
                    ),
                    _c(
                      "w-drawer-item",
                      {
                        attrs: {
                          disabled: !_vm.hasPermission("companies.read"),
                          to: "/referrals",
                        },
                      },
                      [
                        _c("w-fa", { attrs: { icon: "user-friends" } }),
                        _c("span", [_vm._v("Referrals")]),
                      ],
                      1
                    ),
                    _c(
                      "w-drawer-item",
                      {
                        attrs: {
                          disabled: !_vm.hasPermission("discountcodes"),
                          to: "/discount-code",
                        },
                      },
                      [
                        _c("w-fa", { attrs: { icon: "tags" } }),
                        _c("span", [_vm._v("Kortincodes")]),
                      ],
                      1
                    ),
                    _c(
                      "w-drawer-item",
                      {
                        attrs: {
                          disabled: !_vm.hasPermission("scripts"),
                          to: "/scripts",
                        },
                      },
                      [
                        _c("w-fa", { attrs: { icon: "code" } }),
                        _c("span", [_vm._v("Scripts")]),
                      ],
                      1
                    ),
                    _c(
                      "w-drawer-item",
                      {
                        attrs: {
                          disabled: !_vm.hasSpecialPermission,
                          to: "/read-list",
                        },
                      },
                      [
                        _c("w-fa", { attrs: { icon: "list" } }),
                        _c("span", [_vm._v("Ticket lijst")]),
                      ],
                      1
                    ),
                    _c(
                      "w-drawer-item",
                      { attrs: { to: "/settings" } },
                      [
                        _c("w-fa", { attrs: { icon: "cog" } }),
                        _c("span", [_vm._v("Instellingen")]),
                      ],
                      1
                    ),
                    _c(
                      "w-drawer-item",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.logout()
                          },
                        },
                      },
                      [
                        _c("w-fa", { attrs: { icon: "sign-out-alt" } }),
                        _c("span", [_vm._v("Afmelden")]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.$route.path.includes("ticket")
                  ? _c("router-view")
                  : _c("router-view", { key: _vm.$route.path }),
                _c("app-modal-service-container"),
              ],
              1
            ),
          ]
        : !_vm.loggedIn
        ? _c("app-login")
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }